(function () {
  var KEY = 'pg_quote_v1';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function paint() {
    var list = read();
    var n = list.length;
    document.querySelectorAll('[data-pg-qty]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-zero', n === 0);
    });
    document.querySelectorAll('[data-pg-in-quote]').forEach(function (b) {
      var h = b.getAttribute('data-pg-in-quote');
      var on = list.some(function (i) { return i.h === h; });
      b.classList.toggle('is-added', on);
      var lbl = b.querySelector('[data-lbl]');
      if (lbl) lbl.textContent = on ? 'In your cart' : (b.getAttribute('data-label') || 'Add to cart');
    });
  }
  function toast(msg) {
    var t = document.getElementById('pg-toast');
    if (!t) { t = document.createElement('div'); t.id = 'pg-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(window.__pgT);
    window.__pgT = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  function bind() {
    document.querySelectorAll('[data-pg-add]:not([data-bound])').forEach(function (btn) {
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var h = btn.getAttribute('data-pg-add');
        var title = btn.getAttribute('data-title') || h;
        var list = read();
        var i = -1;
        list.forEach(function (x, ix) { if (x.h === h) i = ix; });
        if (i > -1) { list.splice(i, 1); toast('Removed from your cart'); }
        else { list.push({ h: h, t: title, at: Date.now() }); toast(title + ' added to your cart'); }
        write(list); paint();
      });
    });
  }
  function init() { bind(); paint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.pgQuote = { read: read, clear: function () { write([]); paint(); } };
})();
